import axios from "axios";

const salvarLead = async function (bodyreq) {
    var retorno = {}
    const url =  process.env.VUE_APP_ALIANCAADM_ADESAO + '/salvarLead?api-key=' + process.env.VUE_APP_ALIANCAADM_ADESAO_API_KEY;
    try {
        await axios.post(url, bodyreq).then(() => {
                retorno = true
            })
            .catch(error => {
                retorno = false
                console.log(error)
            })
    } catch (e) {
        console.log(e)
    }

    return retorno
};

export default salvarLead;